import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import uuid from 'uuid/v4'
import {isAuthenticated} from '../../../../utils/Session'
import { json, get } from '../../../../utils/ajax'

class ToolMaintainStore {

    @observable list
    @observable pagination
    @observable loading
    @observable modal
    @observable forms
    @observable systemId
    @observable catalogList
    @observable page
    @observable catalogModal
    @observable catalogForm
    @observable manualComboBox
    @observable contentForm
    @observable catalogId
    @observable contents

    constructor () {
        this.list = []
        this.pagination = {}
        this.loading = false
        this.modal = 'hide'
        this.forms = {}
        this.systemId = ''
        this.catalogList = []
        this.page = {}
        this.catalogModal = 'hide'
        this.catalogForm = {
            model : []
        }
        this.manualComboBox = []
        this.contentForm = {}
        this.catalogId = ''
        this.contents = []
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/system/list`,{
            page: page,
            size: 10
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 系统平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            name: {value: this.forms.name},
            image: {value: this.forms.image},
        }
        return fields
    }
    /**
     * 系统将表单时对象化，绑值给store。form
     */
    @action
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            name: fields.name.value,
            image: fields.image.value,
        }
        this.forms = forms
    }

    /**
     * 显示系统编辑框
     */
    @action showMaintain = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 清空forms
     */
    @action empetyForms = () => {
        runInAction(() => {
            this.forms = {}
        })
    }

    /**
     * 新增系统 + 修改系统
     */
    @action saveMaintain = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/system/add`, {
                ...this.forms
            })
            runInAction(() => {
                this.modal = 'hide'
                message.success('保存车型成功')
                this.loading = false
            })
            this.initListPage(this.page)
        }else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/system/update`, {
                ...this.forms
            })
            runInAction(() => {
                this.modal = 'hide'
                message.success('修改车型成功')
                this.loading = false
            })
            this.initListPage(this.page)
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/system/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.forms = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 发布/撤销
     */
    @action
    releaseToCancel= async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/manualCatalogList?id=${rocord.id}`)
        if(res1.length === 0){
            message.warning('该系统下没有目录，请先添加目录！');
            runInAction(() => {
                this.loading = false
            })
            return
        }
        let state = rocord.state? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/system/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            return
        }
        if(state === 1){
            message.success('发布成功！');
        }else{
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.page)
    }

    /**
     *初始化目录
     */
    @action
    initCatalogPage = async (id,page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/list`,{
            page : page,
            size : 10,
            id : id
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.catalogList = res.content
            this.systemId = id
            this.page = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 显示目录编辑框
     */
    @action showCatalog = (flag) => {
        runInAction(() => {
            this.loading = true
            this.catalogModal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 系统目录平行化表单，传值给form
     */
    @computed
    get catalogFields() {
        let catalogFields = {
            id: {value: this.catalogForm.id},
            name: {value: this.catalogForm.name},
            number: {value: this.catalogForm.number},
            model: {value: this.catalogForm.model.slice()},
            image: {value: this.catalogForm.image},
        }
        return catalogFields
    }
    /**
     * 系统目录将表单时对象化，绑值给store。form
     */
    @action
    onEditCatalogFieldChange = (changedFields) => {
        const catalogFields = {...this.catalogFields, ...changedFields}
        let forms = {
            id: catalogFields.id.value,
            name: catalogFields.name.value ? catalogFields.name.value :'',
            number: catalogFields.number.value ? catalogFields.number.value : '',
            model: catalogFields.model.value,
            image: catalogFields.image.value ? catalogFields.image.value :'',
        }
        this.catalogForm = forms
    }

    /**
     * 初始化车型下拉框
     * @returns {Promise.<void>}
     */
    @action initManualAll = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/list?search.state=1&&size=100`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.manualComboBox = res.content
            this.loading = false
        })
    }

    /**
     * 清空CatalogForm
     */
    @action empetyCatalogForm = () => {
        runInAction(() => {
            this.catalogForm = {
                name: '',
                number: '',
                model: [],
                image: '',
            }
        })
    }

    /**
     * 图片上传
     */
    @action imageUpload1 = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 新增系统目录 + 修改系统目录
     */
    @action saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.catalogForm.id) {
            let catalog = {
                name: this.catalogForm.name,
                number: this.catalogForm.number,
                model:this.catalogForm.model.join(','),
                image: this.catalogForm.image,
                systemId:this.systemId,
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/add`,catalog)
            runInAction(() => {
                this.catalogModal = 'hide'
                message.success('保存系统目录成功')
                this.loading = false
            })
            this.initCatalogPage(this.systemId,this.page)
        }else {
            let catalog = {
                id:this.catalogForm.id,
                name: this.catalogForm.name,
                number: this.catalogForm.number,
                model:this.catalogForm.model.join(','),
                image: this.catalogForm.image,
                systemId:this.systemId,
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/update`,catalog)
            runInAction(() => {
                this.catalogModal = 'hide'
                message.success('修改系统目录成功')
                this.loading = false
            })
            this.initCatalogPage(this.systemId,this.page)
        }
    }

    /**
     * 初始化系统目录表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initCatalogEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.catalogForm = {
                id : res.id,
                name : res.name,
                number : res.number,
                model : res.model.split(','),
                image : res.image,
            }
            this.loading = false
            this.catalogModal = 'show'
        })
    }

    /**
     * 删除系统目录
     */
    @action
    deleteCatalogId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initCatalogPage(this.systemId,this.page-1)
        }else{
            await this.initCatalogPage(this.systemId,this.page)
        }
    }

    /**
     * 系统目录内容平行化表单，传值给form
     */
    @computed
    get contentFields() {
        let contentFields = {
            id: {value: this.contentForm.id},
            image: {value: this.contentForm.image},
            name: {value: this.contentForm.name},
            number: {value: this.contentForm.number},
            quantity: {value: this.contentForm.quantity},
            classification: {value: this.contentForm.classification},
            use: {value: this.contentForm.use},
        }
        return contentFields
    }
    /**
     * 系统目录内容将表单时对象化，绑值给store。form
     */
    @action
    onEditContentFieldChange = (changedFields) => {
        const contentFields = {...this.contentFields, ...changedFields}
        let forms = {
            id: contentFields.id.value,
            image: contentFields.image.value,
            name: contentFields.name.value,
            number: contentFields.number.value,
            quantity: contentFields.quantity.value,
            classification: contentFields.classification.value,
            use: contentFields.use.value,
        }
        this.contentForm = forms
    }

    /**
     * 初始化系统目录表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initCatalog = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/content/contentId/${id}`)
        if (res.id === null) {
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/catalog/id/${id}`)
            if (res1 && res1.status === 0) {
                runInAction(() => {
                    this.loading = false
                })
                return
            }
            runInAction(() => {
                this.contentForm = {
                    id : res1.id,
                    name : res1.name,
                    number : res1.number,
                    image : res1.image,
                }
            })
        } else {
            const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/content/contentId/${id}`)
            if (res2 && res2.status === 0) {
                runInAction(() => {
                    this.loading = false
                })
                return
            }
            runInAction(() => {
                this.contentForm = {
                    id : res2.id,
                    name : res2.name,
                    number : res2.number,
                    image : res2.image,
                    quantity : res2.quantity,
                    classification : res2.classification,
                    use : res2.use,
                }
            })
        }
        const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/contentText/searchOne?id=${id}`)
        runInAction(() => {
            this.catalogId = id
            this.contents = contents.length ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: 1,
                    catalogId: id
                }]
            this.loading = false
        })
    }

    /**
     * 新增系统目录内容
     */
    @action saveContent = async () => {
        runInAction(() => {
            this.loading = true
        })
        let contentForm = {
            name : this.contentForm.name,
            number : this.contentForm.number,
            image : this.contentForm.image,
            quantity : this.contentForm.quantity,
            classification : this.contentForm.classification,
            use : this.contentForm.use,
            catalogId : this.catalogId
        }
        if(!contentForm.classification || !contentForm.use || !contentForm.quantity){
            runInAction(() => {
                this.loading = false
            })
            message.info('必填字段不能为空')
            return 0
        }else {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/content/addContent`,contentForm)
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/contentText/addContentText`,this.contents)
        }
        runInAction(() => {
            message.success('保存系统目录成功')
            this.loading = false
        })
    }

    /**
     * 获取到每个编辑器的内容和ID
     */
    @action setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, defaultContent: value}
                }
                return item
            })
        })
    }

    /**
     * 删除编辑框里的图片
     */
    @action delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })
        })
    }

    /**
     * 获取到左图右文的内容和ID
     */
    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId: this.catalogId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    /**
     * 获取到右图左文的内容和ID
     */
    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId: this.catalogId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    /**
     * 删除编辑框里的内容
     */
    @action delContent = (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: 1,
                    catalogId: this.catalogId
                }]
        })
    }

    /**
     * 添加图片
     */
    @action addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    /**
     * 获取ID 用于上移编辑框
     */
    @action contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
    }

    /**
     * 获取ID 用于下移编辑框
     */
    @action contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if(index+1 === this.contents.length){
            return
        }
        if (index >= 0 && index < this.contents.length) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }
}
export default new ToolMaintainStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/ToolManual/ToolMaintain/store.js